import { FormattedMessage } from 'react-intl';
import { roundPrice } from 'lib/pricing_utils';
import type { BreakdownProps } from './types';
import { AddonPrice } from './AddonPrice';
import { BookingFee } from './BookingFee';
import { UnitPrice } from './UnitPrice';

import {
  PriceBreakDown,
  PriceSummaryRow,
  Row,
  LeftColumn,
  RightColumn,
  ToggleIconContainer,
  BreakdownContainer,
} from './styles';

export const Breakdown = ({
  units = { items: [] },
  addons = { items: [] },
  includesBookingFee = false,
  bookingFeeFormatted,
  guestsPriceFormatted,
  includesAdditionalTax = false,
  additionalTaxLabel,
  additionalTaxFormatted,
  includesDiscount = false,
  discountCode,
  discountFormatted,
  includesOnlineDiscount = false,
  onlineDiscountFormatted,
}: BreakdownProps) => {
  return (
    <PriceBreakDown className="PriceBreakDown">
      <BreakdownContainer>
        <Row className="two column row">
          <LeftColumn className="left aligned column">
            <FormattedMessage id="SUBTOTAL" defaultMessage="Subtotal" />
          </LeftColumn>
          <RightColumn className="column" data-testid="actual-value">
            {roundPrice(guestsPriceFormatted || '')}
          </RightColumn>
        </Row>
        <PriceSummaryRow className="two column row PriceBreakdown-summary">
          <UnitPrice {...units} />
        </PriceSummaryRow>
        {addons?.items?.map((addon) => (
          <AddonPrice key={`${addon.name}`} {...addon} />
        ))}
        {includesDiscount && (
          <Row className="two column row">
            <LeftColumn className="left aligned column">
              <FormattedMessage id="PROMO_CODE" defaultMessage="Promo Code" />:{' '}
              <br />
              {discountCode}
            </LeftColumn>
            <RightColumn className="column" data-testid="promo-value">
              {roundPrice(discountFormatted || '')}
              <ToggleIconContainer className="toggleIconContainer">
                <span className="icon af-minus-ar" />
              </ToggleIconContainer>
            </RightColumn>
          </Row>
        )}
        {includesAdditionalTax && (
          <Row className="two column row">
            <LeftColumn className="left aligned column">
              {additionalTaxLabel ? (
                <span className="additional-tax-label">
                  {additionalTaxLabel}
                </span>
              ) : (
                <FormattedMessage defaultMessage="VAT" />
              )}
            </LeftColumn>
            <RightColumn className="column">
              {roundPrice(additionalTaxFormatted || '')}
            </RightColumn>
          </Row>
        )}
        {includesOnlineDiscount && (
          <Row className="two column row">
            <LeftColumn className="left aligned column">
              <FormattedMessage defaultMessage="Online Payment Discount" />
            </LeftColumn>
            <RightColumn className="column">
              {roundPrice(onlineDiscountFormatted || '')}
              <ToggleIconContainer className="toggleIconContainer">
                <span className="icon af-minus-ar" />
              </ToggleIconContainer>
            </RightColumn>
          </Row>
        )}
        <BookingFee
          includesBookingFee={includesBookingFee}
          bookingFeeFormatted={bookingFeeFormatted || ''}
        />
      </BreakdownContainer>
    </PriceBreakDown>
  );
};
